import React from "react";
import { Box, Text } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { Carousel } from '@mantine/carousel';

import { ROOT_BASE_URL } from "../../utils/globalVariables";

const CarouselPhotos = ({ stateData, stateUtils, stateWhenNoData, fnOnClickImage, fnOnClickDelete }) => {
  return (
    <React.Fragment>
      {stateWhenNoData.showThisComponent && Array.isArray(stateData.data) && (stateData.data.length <= 0) &&
        <Box>
          {stateWhenNoData.component}
        </Box>
      }

      {Array.isArray(stateData.data) && (stateData.data.length > 0) &&
        <Box>
          {stateUtils.showImageCounter &&
            <Text mb='sm' size='sm'>Photos ({stateData.data.length})</Text>
          }

          <Carousel
            withIndicators={false}
            withControls={Array.isArray(stateData.data) && (stateData.data.length > 1)}
            height={stateUtils.heightImage}
            slideSize={stateUtils.slideSize}
            slideGap="xs"
            loop={false}
            align="start"
          >
            {Object.keys(stateData.data).map((keyCP, indexCP) => {
              return (
                <Carousel.Slide
                  key={keyCP}
                  sx={(tema) => ({
                    height: stateUtils.heightImage + 1 + 'px',
                  })}
                >
                  <Box
                    sx={(tema) => ({
                      position: 'relative',
                      height: stateUtils.heightImage + 2 + 'px',

                      borderRadius: tema.radius.sm,
                      borderWidth: '1px',
                      borderStyle: 'solid',
                      borderColor: tema.colorScheme === 'light' ? tema.colors.gray[3] : tema.colors.dark[4]
                    })}
                  >
                    <img
                      alt={`${stateUtils.imgAlt}-${indexCP}`}
                      src={`${ROOT_BASE_URL}${stateData.data[keyCP][stateData.propName]}`}
                      style={{
                        width: '100%',
                        height: stateUtils.heightImage + 'px',
                        objectFit: 'cover'
                      }}

                      onClick={() => fnOnClickImage({
                        images: stateData.data,
                        title: stateData.imageTitleOnClick,
                        index: keyCP,
                        fieldName: stateData.propName
                      })}
                    />

                    {stateData.canDelete ?
                      <Box
                        px='.5rem'
                        sx={(tema) => ({
                          height: '30px',
                          backgroundColor: tema.fn.rgba(tema.colors.blue[9], 0.75),
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          right: 0,
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          cursor: 'pointer',
                          userSelect: 'none',
                          // borderBottomLeftRadius: tema.radius.sm,
                          // borderBottomRightRadius: tema.radius.sm,
                        })}

                        onClick={() => fnOnClickDelete({
                          id: stateData.data[keyCP][stateData.propId],
                          name: stateData.data[keyCP][stateData.propName],
                        })}
                      >
                        <Text color="#fff">
                          {String(Number(keyCP) + 1)}
                        </Text>

                        <IconTrash
                          size={16}
                          color='#fff'
                        />
                      </Box>
                      :
                      <Box
                        px='.5rem'
                        sx={(tema) => ({
                          height: '30px',
                          backgroundColor: tema.fn.rgba(tema.colors.blue[9], 0.75),
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          right: 0,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          userSelect: 'none',
                          // borderBottomLeftRadius: tema.radius.sm,
                          // borderBottomRightRadius: tema.radius.sm,
                        })}
                      >
                        <Text color="#fff">
                          {String(Number(keyCP) + 1)}
                        </Text>
                      </Box>
                    }
                  </Box>
                </Carousel.Slide>
              )
            })}
          </Carousel>
        </Box>
      }
    </React.Fragment>
  )
}

export default React.memo(CarouselPhotos);